import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './MinusPhraseLibraryNameCell.css';

export interface MinusPhraseLibraryNameCellProps {
    name: string;
    id: string;
}

export class MinusPhraseLibraryNameCell extends React.PureComponent<MinusPhraseLibraryNameCellProps> {
    render() {
        const { name, id } = this.props;

        return (
            <div className={Bem.cls('minus-phrase-library-name-cell')}>
                <h3 className={Bem.cls('minus-phrase-library-name-cell', 'title')}>{name}</h3>
                <div className={Bem.cls('minus-phrase-library-name-cell', 'phrases-count')}>№ {id}</div>
            </div>
        );
    }
}
